import { render, staticRenderFns } from "./reviewPaperDetail.vue?vue&type=template&id=a50f7c84&scoped=true"
import script from "./reviewPaperDetail.vue?vue&type=script&lang=js"
export * from "./reviewPaperDetail.vue?vue&type=script&lang=js"
import style0 from "./reviewPaperDetail.vue?vue&type=style&index=0&id=a50f7c84&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50f7c84",
  null
  
)

export default component.exports